import { makePersisted } from '@solid-primitives/storage';
import { useCurrency, accountStatusEnum } from '@bz/common';
import CreditTipsDialog from '@bz/wallet/src/routes/dialog/CreditTipsDialog';
import { SignalLike } from '@bz/ui/src/components/contexts';

import currencyConvertHint from '~/utils/formatCurrency';

export default function VipCreditNotice({
  class: className,
  isBetSlip,
  bind,
}: {
  class?: string;
  bind: SignalLike<boolean>;
  isBetSlip?: boolean;
}) {
  const { latestCurrency, isCash, walletCreditInfo, hasCredit } = useCurrency();
  const [creditDialogState, setCreditDialogState] = makePersisted(
    createSignal<{ hasCreditDialogShowed: boolean }>({ hasCreditDialogShowed: false }),
    { name: 'has-credit-dialog-showed' }
  );
  const handleChange = (isOn: boolean) => {
    bind[1](isOn);
    if (isBetSlip && !creditDialogState().hasCreditDialogShowed) {
      pop.push(() => (
        <Pop title={t('VIP CREDITS')} class="min-h-[860px] bg-layer3-card pt-3 [&>.pop-title]:!bg-layer4-card">
          <CreditTipsDialog />
        </Pop>
      ));
      setCreditDialogState({ hasCreditDialogShowed: true });
    }
  };
  return (
    <Show when={isCash() && hasCredit() && walletCreditInfo()?.accountStatus !== accountStatusEnum.DISABLE}>
      <div class={`${className || ''} rounded-md h-7 caption-s-medium flex items-center justify-between gap-2`}>
        <div>
          <span class="text-neutral-main1">{t('Use VIP Credits')}</span>
          <span class="text-function-highlight">
            {' '}
            ({t('Balance: ')}
            {currencyConvertHint(walletCreditInfo()?.availableBalance ?? 0, 'USDT', latestCurrency(), 'transaction')}
            {/* {addVipBalance()}
            {latestCurrency()} */}
            )
          </span>
        </div>
        <SwitchUI class="bg-layer3" value={bind[0]()} size="small" onChange={handleChange} />
      </div>
    </Show>
  );
}
